// import angular from 'angular';
import angular from 'angular';
import application from 'application/application';

const controller = 'DefaultInputTypesController';

application.controller(controller, [
	'$scope',
	'$rootScope',
	'$element',
	'helper',
	'$http',
	'API',
	'authentication',
	'$stateParams',
	(
		$scope,
		$rootScope,
		$element,
		helper,
		$http,
		API,
		authentication,
		$stateParams
	) => {
		// list of event types
		$scope.eventsTypes = helper.responseStore();

		let getEvents = sessionStorage.getItem('__EVENTS_TYPES__');

		if (getEvents) {
			$scope.eventsTypes.setItems(JSON.parse(getEvents));
			$scope.eventsTypes.setReady(true);
		}

		$scope.titleAllTypes = angular.copy($scope.title) || 'Tipos';

		if ($scope.eventsTypes.getItems() && $stateParams.tipo) {
			$scope.titleAllTypes = $stateParams.tipo
				? $scope.eventsTypes
						.getItems()
						.filter(value => value.id == $stateParams.tipo)[0].nome
				: $scope.titleAllTypes;
		}

		$rootScope.configInputTypes = {
			id: $stateParams.tipo ? Number($stateParams.tipo) : 0,
			reload: () => {
				// Invoca a expressão recebida no atributo reload
				$scope.reload(); // Chama a função passada na diretiva
			}
		};

		$scope.expandedAllTypesFilter = false;

		// /** Método que expande o filtro de tipos de eventos personalizado */
		$scope.expandedAllTypes = () => {
			var checkboxes = document.getElementById('checkboxesAllTypes');
			var arrow = document.getElementById('arrowAllTypes');
			var searchInput = document.getElementById('pesqDeadlines');
			var searchFilterLink = document.getElementById('searchFilterLink');

			if (document.activeElement === searchInput) {
				if (searchFilterLink) {
					searchFilterLink.click();
				}

				return;
			}

			$scope.clearSearch('tipos', 'inputTiposPrazos');

			setTimeout(() => {
				$scope.closeAllTypes(checkboxes, arrow);
			}, 100);

			if ($scope.eventsTypes.hasNotItems())
				$scope.recordEventsTypes($scope.eventsTypes);

			if (!$scope.expandedAllTypesFilter) {
				checkboxes.style.display = 'block';
				$scope.expandedAllTypesFilter = true;

				arrow.style.transform = 'rotate(180deg)';
			} else {
				checkboxes.style.display = 'none';
				$scope.expandedAllTypesFilter = false;

				arrow.style.transform = 'rotate(360deg)';
			}
		};

		$scope.hasFilter = () => {
			if ($rootScope.configInputTypes.id) return true;

			return false;
		};

		/** Método que fecha filtro de tipos de eventos personalidado */
		$scope.closeAllTypes = (checkboxes, arrow) => {
			$(document).on('click', function(e) {
				if ($(e.target).is('.clickoutCampanha')) return;

				if (!$(e.target).is('.searchingAllTypes')) {
					if ($scope.expandedAllTypesFilter === true) {
						checkboxes.style.display = 'none';
						$scope.expandedAllTypesFilter = false;
						arrow.style.transform = 'rotate(360deg)';
					}
				}
			});
		};

		$scope.recordEventsTypes = (responseStore, showModal) => {
			responseStore.setReady(false);
			const idCliente =
				parseInt(authentication.getUserData('idCliente'), 10) || undefined;

			$http({
				...helper.http(API.eventsTypes, 'GET'),
				params: { ...helper.httpFields(['*']), idCliente }
			})
				.then(response => responseStore.setItems(response.data.itens))
				.finally(() => {
					$scope.titleAllTypes = $stateParams.tipo
						? responseStore
								.getItems()
								.filter(value => value.id == $stateParams.tipo)[0].nome
						: 'Todos prazos';

					responseStore.setReady(true);

					$rootScope.formCreatePrazo.eventsTypes = responseStore;

					// Converte o array para uma string e armazena no Session Storage
					sessionStorage.setItem(
						'__EVENTS_TYPES__',
						JSON.stringify(responseStore.getItems())
					);

					setTimeout(() => {
						if (showModal) $('#modalCreateAgendaEventComponent').modal('show');

						// $scope.$resetFormValidation('createEvent')();
					}, 100);
				});
		};

		$scope.btnClearAllTypes = () => {
			$scope.clearFilter();
		};

		// eslint-disable-next-line space-before-function-paren
		$scope.clearFilter = function() {
			$scope.clear = true;

			$rootScope.configInputTypes.id = 0;
			$scope.titleAllTypes = $element[0].title;

			$rootScope.configInputTypes.reload &&
				$rootScope.configInputTypes.reload();
		};

		/** Método que limpa pesquisa dentro dos filtros */
		$scope.clearSearch = (key, id) => {
			if (key == 'tipos') {
				$scope.allTypesClose = false;
				$scope.notAllTypes = false;
				$scope.allTypesSearch = '';

				if ($scope.eventsTypes.hasNotItems())
					$scope.recordEventsTypes($scope.eventsTypes);
			}

			document.getElementById(id).value = '';
		};

		$scope.allTypesSearch = '';
		$scope.allTypesClose = false;

		/** Método para pesquisa de tipos dentro do filtro */
		$scope.allTypesPesq = async AllTypes => {
			if (AllTypes.length > 2) {
				if (!$scope.guardAllTypes)
					$scope.guardAllTypes = helper.cloneSimpleObject(
						$scope.eventsTypes.getItems()
					);

				let record = $scope.guardAllTypes.filter(item => {
					return item.nome.toLowerCase().indexOf(AllTypes.toLowerCase()) > -1;
				});

				$scope.eventsTypes.setItems(record);

				record.length
					? ($scope.notAllTypes = false)
					: ($scope.notAllTypes = true);

				if (AllTypes.length) $scope.allTypesClose = true;
			} else if (!AllTypes.length && $scope.guardAllTypes) {
				$scope.eventsTypes.setItems($scope.guardAllTypes);
				$scope.notAllTypes = false;
				$scope.allTypesClose = false;
			}
		};

		/** Método para previnir click na tecla enter dentro dos filtros
		 * para não causar erros
		 */
		$scope.keypressEnter = event => {
			event.preventDefault();
		};

		$scope.allTypesSelected = AllTypes => {
			$scope.title = AllTypes.nome;
			$rootScope.configInputTypes.id = AllTypes.id;
			$scope.titleAllTypes = AllTypes.nome;

			$rootScope.configInputTypes.reload &&
				$rootScope.configInputTypes.reload();

			$scope.expandedAllTypes('111b');
		};
	}
]);

export default controller;
